document.documentElement.classList.remove('no-js');

document.addEventListener('click', (e) => {
  const menuBtn = e.target.closest('[data-mobile-menu]');
  if (menuBtn) {
    const drawer = document.querySelector('[data-mobile-drawer]');
    drawer?.classList.toggle('is-open');
    menuBtn.setAttribute('aria-expanded', drawer?.classList.contains('is-open') ? 'true' : 'false');
  }
  const q = e.target.closest('[data-faq-question]');
  if (q) {
    const item = q.closest('.cr-faq-premium__item, .cr-faq-item, .faq-item');
    item?.classList.toggle('is-open');
    q.setAttribute('aria-expanded', item?.classList.contains('is-open') ? 'true' : 'false');
  }
});

function setCountdownParts(el, diff) {
  const parts = {
    days: el.querySelector('[data-days]'),
    hours: el.querySelector('[data-hours]'),
    minutes: el.querySelector('[data-minutes]'),
    seconds: el.querySelector('[data-seconds]')
  };
  const safeDiff = Math.max(0, diff);
  const d = Math.floor(safeDiff / 86400000);
  const h = Math.floor(safeDiff / 3600000) % 24;
  const m = Math.floor(safeDiff / 60000) % 60;
  const s = Math.floor(safeDiff / 1000) % 60;
  if (parts.days) parts.days.textContent = d;
  if (parts.hours) parts.hours.textContent = String(h).padStart(2, '0');
  if (parts.minutes) parts.minutes.textContent = String(m).padStart(2, '0');
  if (parts.seconds) parts.seconds.textContent = String(s).padStart(2, '0');
}

function startCountdownRange(el) {
  const start = new Date(el.dataset.start).getTime();
  const end = new Date(el.dataset.end).getTime();
  if (Number.isNaN(start) || Number.isNaN(end)) return;

  const status = el.querySelector('[data-countdown-status]');
  const beforeText = el.dataset.beforeText || 'The challenge begins in';
  const duringText = el.dataset.duringText || 'The challenge is live — time left to conquer it';
  const afterText = el.dataset.afterText || 'The event has finished.';

  const tick = () => {
    const now = Date.now();
    if (now < start) {
      el.dataset.phase = 'before';
      if (status) status.textContent = beforeText;
      setCountdownParts(el, start - now);
    } else if (now <= end) {
      el.dataset.phase = 'live';
      if (status) status.textContent = duringText;
      setCountdownParts(el, end - now);
    } else {
      el.dataset.phase = 'ended';
      if (status) status.textContent = afterText;
      setCountdownParts(el, 0);
    }
  };

  tick();
  setInterval(tick, 1000);
}

document.querySelectorAll('[data-countdown-range]').forEach(startCountdownRange);

/* Backward compatibility for countdown sections added from older presets. */
function startCountdown(el){
  const target = new Date(el.dataset.target).getTime();
  if(!target || Number.isNaN(target)) return;
  const tick=()=>setCountdownParts(el,target-Date.now());
  tick();
  setInterval(tick,1000);
}
document.querySelectorAll('[data-countdown]:not([data-countdown-range])').forEach(startCountdown);

function initConfidenceCarousel(section = document) {
  section.querySelectorAll('[data-confidence-section]').forEach((root) => {
    if (root.dataset.carouselReady === 'true') return;
    root.dataset.carouselReady = 'true';
    const viewport = root.querySelector('[data-confidence-viewport]');
    const prev = root.querySelector('[data-confidence-prev]');
    const next = root.querySelector('[data-confidence-next]');
    if (!viewport) return;

    const stepSize = () => {
      const card = viewport.querySelector('.cr-confidence-card');
      if (!card) return viewport.clientWidth * 0.8;
      const track = viewport.querySelector('.cr-confidence__track');
      const gap = track ? parseFloat(getComputedStyle(track).gap || 0) : 0;
      return card.getBoundingClientRect().width + gap;
    };

    prev?.addEventListener('click', () => viewport.scrollBy({ left: -stepSize(), behavior: 'smooth' }));
    next?.addEventListener('click', () => viewport.scrollBy({ left: stepSize(), behavior: 'smooth' }));
  });
}

initConfidenceCarousel();
document.addEventListener('shopify:section:load', (event) => initConfidenceCarousel(event.target));

function initProductGalleries(section = document) {
  section.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    if (gallery.dataset.galleryReady === 'true') return;
    gallery.dataset.galleryReady = 'true';

    const viewport = gallery.querySelector('[data-product-gallery-viewport]');
    const items = Array.from(gallery.querySelectorAll('[data-product-media-index]'));
    const dots = Array.from(gallery.querySelectorAll('[data-product-gallery-dot]'));
    const current = gallery.querySelector('[data-product-gallery-current]');
    if (!viewport || items.length < 2) return;

    let frame;
    const setActive = (index) => {
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      if (current) current.textContent = String(index + 1);
    };

    const updateActive = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const left = viewport.getBoundingClientRect().left;
        let closest = 0;
        let distance = Infinity;
        items.forEach((item, index) => {
          const d = Math.abs(item.getBoundingClientRect().left - left);
          if (d < distance) {
            distance = d;
            closest = index;
          }
        });
        setActive(closest);
      });
    };

    viewport.addEventListener('scroll', updateActive, { passive: true });
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        items[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });
    setActive(0);
  });
}

initProductGalleries();
document.addEventListener('shopify:section:load', (event) => initProductGalleries(event.target));

/* V17: reserve space for the compact mobile registration bar. */
function initStickyRegister(section = document) {
  if (section.querySelector?.('[data-sticky-register]') || document.querySelector('[data-sticky-register]')) {
    document.body.classList.add('has-cr-sticky-register');
  }
}
initStickyRegister();
document.addEventListener('shopify:section:load', (event) => initStickyRegister(event.target));
document.addEventListener('shopify:section:unload', () => {
  if (!document.querySelector('[data-sticky-register]')) document.body.classList.remove('has-cr-sticky-register');
});

/* V24 — premium product options, quantity control, and dual cart/checkout flow */
function initPremiumProductForms(section = document) {
  section.querySelectorAll('[data-premium-product-section]').forEach((productSection) => {
    if (productSection.dataset.premiumProductReady === 'true') return;
    productSection.dataset.premiumProductReady = 'true';

    const form = productSection.querySelector('[data-product-form]');
    const variantsScript = productSection.querySelector('[data-product-variants-json]');
    const variantInput = productSection.querySelector('[data-selected-variant-id]');
    const returnTo = productSection.querySelector('[data-product-return-to]');
    const price = productSection.querySelector('[data-product-price]');
    const note = productSection.querySelector('[data-product-form-note]');
    const optionGroups = Array.from(productSection.querySelectorAll('[data-product-option-group]'));
    const actionButtons = Array.from(productSection.querySelectorAll('[data-product-action]'));
    const quantityInput = productSection.querySelector('[data-quantity-input]');
    const quantityMinus = productSection.querySelector('[data-quantity-minus]');
    const quantityPlus = productSection.querySelector('[data-quantity-plus]');

    if (!form || !variantInput) return;

    let variants = [];
    try { variants = variantsScript ? JSON.parse(variantsScript.textContent) : []; } catch (_) { variants = []; }

    const money = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-MY', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'MYR'
        }).format((Number(cents) || 0) / 100);
      } catch (_) {
        return `RM${((Number(cents) || 0) / 100).toFixed(2)}`;
      }
    };

    const selectedValues = () => optionGroups.map((group) => group.querySelector('.cr-option-pill.is-selected')?.dataset.optionValue || '');

    const findVariant = (values) => variants.find((variant) => {
      const opts = Array.isArray(variant.options) ? variant.options : [];
      return values.every((value, index) => String(opts[index]) === String(value));
    });

    const updateOptionAvailability = () => {
      if (!variants.length || !optionGroups.length) return;
      const current = selectedValues();
      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-option-value]').forEach((pill) => {
          const test = [...current];
          test[groupIndex] = pill.dataset.optionValue;
          const possible = variants.some((variant) => {
            const opts = Array.isArray(variant.options) ? variant.options : [];
            return opts.every((opt, index) => index === groupIndex ? String(opt) === String(test[index]) : (!test[index] || String(opt) === String(test[index]))) && variant.available;
          });
          pill.classList.toggle('is-unavailable', !possible);
          pill.setAttribute('aria-disabled', possible ? 'false' : 'true');
        });
      });
    };

    const updateVariant = () => {
      if (!variants.length) return;
      const variant = findVariant(selectedValues());
      const available = Boolean(variant?.available);
      if (variant) variantInput.value = variant.id;
      if (price && variant) price.textContent = money(variant.price);
      actionButtons.forEach((button) => {
        button.disabled = !available;
        if (!available) button.textContent = 'Sold out';
        else if (button.dataset.productAction === 'cart') button.textContent = 'Add to cart';
        else button.innerHTML = 'Checkout <span aria-hidden="true">→</span>';
      });
      if (note) {
        note.textContent = variant && !available ? 'This option is currently sold out.' : '';
        note.classList.toggle('is-error', Boolean(variant && !available));
      }
      if (variant?.id && history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
      updateOptionAvailability();
    };

    optionGroups.forEach((group) => {
      group.querySelectorAll('[data-option-value]').forEach((pill) => {
        pill.addEventListener('click', () => {
          group.querySelectorAll('[data-option-value]').forEach((candidate) => {
            const active = candidate === pill;
            candidate.classList.toggle('is-selected', active);
            candidate.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          updateVariant();
        });
      });
    });

    const clampQuantity = (value) => Math.max(1, Number.parseInt(value, 10) || 1);
    quantityMinus?.addEventListener('click', () => { if (quantityInput) quantityInput.value = clampQuantity(Number(quantityInput.value) - 1); });
    quantityPlus?.addEventListener('click', () => { if (quantityInput) quantityInput.value = clampQuantity(Number(quantityInput.value) + 1); });
    quantityInput?.addEventListener('change', () => { quantityInput.value = clampQuantity(quantityInput.value); });

    actionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (returnTo) returnTo.value = button.dataset.productAction === 'checkout' ? '/checkout' : '/cart';
      });
    });

    updateVariant();
  });
}

initPremiumProductForms();
document.addEventListener('shopify:section:load', (event) => initPremiumProductForms(event.target));
